// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2aRbA","title":"Info_title__3E1QR","links":"Info_links__33KqK","link":"Info_link__TsIaE","logo":"Info_logo__3-MGu"};